// src/pages/Courses/Courses.js
import React, { useState, useMemo } from 'react';
import './Courses.css';
import { courseData } from '../../data/CoursesData';

const Courses = () => {
  const categories = ['All Categories', ...new Set(courseData.map(course => course.category))];
  const levels = ['All Levels', 'Beginner', 'Intermediate', 'Advanced'];

  const [selectedCategory, setSelectedCategory] = useState('All Categories');
  const [selectedLevel, setSelectedLevel] = useState('All Levels');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name');

  const filteredCourses = useMemo(() => {
    let filtered = courseData;

    if (selectedCategory !== 'All Categories') {
      filtered = filtered.filter(course => course.category === selectedCategory);
    }

    if (selectedLevel !== 'All Levels') {
      filtered = filtered.filter(course => course.level === selectedLevel);
    }

    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filtered = filtered.filter(course => 
        course.name.toLowerCase().includes(term) ||
        course.category.toLowerCase().includes(term)
      );
    }

    switch (sortBy) {
      case 'name':
        filtered.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case 'fee-low':
        filtered.sort((a, b) => parseFloat(a.fee.replace(/,/g, '')) - parseFloat(b.fee.replace(/,/g, '')));
        break;
      case 'fee-high':
        filtered.sort((a, b) => parseFloat(b.fee.replace(/,/g, '')) - parseFloat(a.fee.replace(/,/g, '')));
        break;
      case 'duration':
        filtered.sort((a, b) => {
          const aWeeks = parseInt(a.duration);
          const bWeeks = parseInt(b.duration);
          return aWeeks - bWeeks;
        });
        break;
      default:
        break;
    }

    return filtered;
  }, [selectedCategory, selectedLevel, searchTerm, sortBy]);

  const getBadgeClass = (level) => {
    switch(level) {
      case 'Beginner': return 'course-badge-beginner';
      case 'Intermediate': return 'course-badge-intermediate';
      case 'Advanced': return 'course-badge-advanced';
      default: return '';
    }
  };

  return (
    <div className="courses-page">
      <div className="courses-hero">
        <div className="courses-hero-content">
          <h1>Discover Our <span>Training Programs</span></h1>
          <p>Explore our comprehensive range of technical and professional training programs designed to build your career</p>
        </div>
      </div>

      <div className="courses-container">
        <div className="courses-filters">
          <div className="search-box">
            <input
              type="text"
              placeholder="🔍 Search courses by name or category..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          <div className="filter-group">
            <select
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
              className="filter-select"
            >
              {categories.map(category => (
                <option key={category} value={category}>{category}</option>
              ))}
            </select>

            <select
              value={selectedLevel}
              onChange={(e) => setSelectedLevel(e.target.value)}
              className="filter-select"
            >
              {levels.map(level => (
                <option key={level} value={level}>{level}</option>
              ))}
            </select>

            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="filter-select"
            >
              <option value="name">Sort by Name</option>
              <option value="fee-low">Fee: Low to High</option>
              <option value="fee-high">Fee: High to Low</option>
              <option value="duration">Sort by Duration</option>
            </select>
          </div>
        </div>

        <div className="courses-stats">
          <span>📚 Showing {filteredCourses.length} of {courseData.length} courses</span>
        </div>

        <div className="courses-grid">
          {filteredCourses.map(course => (
            <div key={course.id} className="course-card">
              <div className="course-card-header">
                <span className={`course-badge ${getBadgeClass(course.level)}`}>
                  {course.level}
                </span>
                <span className="course-category">{course.category}</span>
              </div>
              <h3 className="course-name">{course.name}</h3>
              <div className="course-details">
                <div className="course-detail">
                  <span className="detail-icon">⏱️</span>
                  <span>{course.duration}</span>
                </div>
                <div className="course-detail">
                  <span className="detail-icon">💰</span>
                  <span className="course-fee">Rs. {course.fee}</span>
                </div>
              </div>
              <button className="course-enroll-btn">Enroll Now →</button>
            </div>
          ))}
        </div>

        {filteredCourses.length === 0 && (
          <div className="no-courses">
            <p>😕 No courses found matching your criteria. Try adjusting your filters.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Courses;